const notConfirmSignUp = ({ store, redirect }) => {
  // If the user is not confirm redirect to login
  if (store.state.auth.userConfirm.status || !store.state.auth.userConfirm.email) {
    return redirect('/');
  }
};

export default notConfirmSignUp;
